import React, { useState, useEffect } from "react";
import { Menu, X, ChevronDown, ArrowRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/Logo_Desktop.svg";

import RoundedArrowButton from "./RoundedArrowButton"

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Close menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav className="absolute font-generalsans-description top-6 px-[24px] w-full z-50  ">
      <div className="max-w-7xl md:h-[86px] h-[67px] mx-auto bg-white/90 backdrop-blur-md shadow-sm rounded-full px-4 md:px-8 py-3 flex items-center justify-between">
        
        {/* Logo */}
        <div className="flex items-center gap-2">
          <Link to="/">
            <img src={logo} alt="Arambh Logo" className=" md:w-[135px] md:h-[39px] w-[102px]" />
          </Link>
        </div>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-6">
          <Link to="/" className="text-[#2C3075] font-medium hover:font-[500]">Home</Link>
          <Link to="/aboutus" className="text-[#2C3075] font-medium hover:font-[500]">About us</Link>
          <div className="relative group">
            <button className="flex items-center gap-1 text-[#2C3075] font-medium">
              <Link to="/services">
              
              Services
             </Link>
            </button>
             {/* <ChevronDown size={ 16 } /> */}
          </div>
        </div>

        {/* Contact Button */}
        <div className="hidden md:block">
                <RoundedArrowButton label="Contact Us" to="/contact" />
          
       </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-[#2C3075]"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="absolute top-[calc(100%+8px)] left-0 h-[600px] w-full bg-white shadow-lg rounded-lg p-6 md:hidden">
          <Link to="/" className="block py-2 text-[#2C3075] font-medium">Home</Link>
          <Link to="/aboutus" className="block py-2 text-[#2C3075] font-medium">About us</Link>
          <Link to="/services" className="block py-2 text-[#2C3075] font-medium">Services</Link>
          <div className="md:hidden absolute left-6 bottom-8 z-20">
            <RoundedArrowButton label="Contact Us" to="/contact" />
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;

